<template>
  <td class="border-b border-l">
    <template v-if="claim && !claim.rejected_at">
      <popper
        trigger="click"
        class=""
        :options="{
          placement: 'bottom',
          modifiers: {
            offset: {
              offset: '0,8px'
            }
          }
        }"
      >
        <div
          class="bg-white shadow-md border-t-2 min-w-32"
          :class="{
            'border-neutral-500 text-neutral-500': !claim.approved_at,
            'border-positive-500 text-positive-500':
              claim.approved_at && !claim.paid_at,
            'border-primary-500 text-primary-500': claim.paid_at
          }"
        >
          <ul class="list-reset text-black text-center">
            <template v-if="!claim.approved_at">
              <li>
                <button
                  class="px-4 py-2 text-positive-800 hover:bg-positive-100 w-full font-bold"
                  @click="$emit('claim:approve', claim.id)"
                >
                  Approve
                </button>
              </li>
              <li>
                <button
                  class="px-4 py-2 text-negative-800 hover:bg-negative-100 w-full font-bold"
                  @click="$emit('claim:reject', claim.id)"
                >
                  Reject
                </button>
              </li>
            </template>
            <template v-else-if="!claim.paid_at">
              <li>
                <button
                  class="px-4 py-2 text-primary-800 hover:bg-primary-100 w-full font-bold"
                  @click="$emit('claim:pay', claim.id)"
                >
                  Mark As Paid
                </button>
              </li>
            </template>
            <li class="border-t">
              <button
                class="px-4 py-2 hover:text-primary-800 text-black w-full"
                @click="showBankDetails"
              >
                Bank Details
              </button>
            </li>
            <li
              v-if="claim.invoice_file_id"
              class="px-4 py-2"
            >
              <a
                class="block no-underline hover:text-primary-800 text-black"
                target="_blank"
                :href="
                  route('applications.files.download', {
                    application: projectUuid,
                    file: claim.invoice_file_id,
                    project: true
                  })
                "
                download
              >
                Information
              </a>
            </li>
          </ul>
        </div>
        <div
          slot="reference"
          class="flex justify-between px-4 py-2 focus:outline-none focus:shadow-outline cursor-pointer text-black"
          :class="{
            'bg-neutral-100 hover:bg-neutral-200 focus:bg-neutral-200 italic': !claim.approved_at,
            'bg-positive-100 hover:bg-positive-200 focus:bg-positive-200':
              claim.approved_at && !claim.paid_at,
            'bg-primary-100 hover:bg-primary-200 focus:bg-primary-200':
              claim.paid_at
          }"
          tabindex="0"
        >
          <strong>£</strong>
          <span class="text-right flex-no-shrink flex-grow">
            {{ claimValue }}
          </span>
        </div>
      </popper>
    </template>
    <template v-else>
      <div
        class="flex justify-between px-4 bg-grey-100 py-2 focus:outline-none focus:shadow-outline text-grey-600"
      >
        <strong>£</strong>
        <span class="text-right flex-no-shrink flex-grow">
          {{ claimValue }}
        </span>
      </div>
    </template>
  </td>
</template>

<script>
import Popper from "vue-popperjs";
export default {
  name: "FundingProjectClaimValue",
  components: { Popper },
  props: {
    projectUuid: {
      type: String,
      required: true
    },
    partner: {
      type: Object,
      required: true
    },
    claimPeriod: {
      type: String,
      required: true
    },
    claims: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    }
  },
  computed: {
    claim() {
      return this.claims.find(request => {
        return (
          request.claim_period === this.claimPeriod &&
          request.competition_project_partner_id === this.partner.id
        );
      });
    },
    claimValue() {
      return this.claim && this.claim.value && !this.claim.rejected_at
        ? this.claim.value.toLocaleString("en-GB", { minimumFractionDigits: 2 })
        : "---";
    }
  },
  methods: {
    showBankDetails() {
      return this.$emit("claim:bank", this.partner.id);
    }
  }
};
</script>
